import { DefaultTopicTypeResponseData } from "./publicationTopicType.interface";

export const adaptTopicType = (originalData: DefaultTopicTypeResponseData) => {
  const sortedEntries = Object.entries(originalData.data)
    .sort(([, a], [, b]) => a.viewOrder - b.viewOrder)
    .reduce((acc, [key, value]) => {
      acc[key] = value.displayValue;
      return acc;
    }, {} as Record<string, string>);

  return sortedEntries;
};

export const adaptTopicTypeName = (
  originalData: DefaultTopicTypeResponseData,
) => {
  const sortedEntries = Object.entries(originalData.data)
    .sort(([, a], [, b]) => a.viewOrder - b.viewOrder)
    .reduce((acc, [key, value]) => {
      acc[value.displayValue] = key;
      return acc;
    }, {} as Record<string, string>);

  return sortedEntries;
};
